import React from "react";
import { graphql, useStaticQuery } from 'gatsby';
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";

import { Helmet } from 'react-helmet'

import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";

import DefaultLayout from "layouts/default.jsx";
// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Banner from "components/Banner/Banner.jsx";
import Avatar from '@material-ui/core/Avatar';
import HeroCard from 'components/HeroCard/HeroCard.jsx';
import Quote from "components/Quote/Quote.jsx";
import QuoteFact from "components/QuoteFact/QuoteFact.jsx";
import Fact from "components/Fact/Fact.jsx";

import CompassBlue from "components/Background/CompassBlue.jsx";

import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";

// Sections for this page
import TeamSection from "sections/AboutPage/TeamSection.jsx";
import BlogSection from "sections/AboutPage/BlogSection.jsx";

import EarlyAdopterCTA from "sections/CTAs/EarlyAdopterCTA.jsx";
import MissingStepCTA from "sections/CTAs/MissingStepCTA.jsx";
import JoinTheMovementCta from "sections/CTAs/JoinTheMovementCTA.jsx";
import OurSharesCTA from "sections/CTAs/OurSharesCTA.jsx";
import YourSharesMyFutureCTA from "sections/CTAs/YourSharesMyFutureCTA.jsx";

import facts from "data/facts.json";
import quotes from "data/quotes.json";

import aboutHero from "data/about-hero.json";
import missionHero from "data/mission-hero.json";
import publicBenefitHero from "data/public-benefit-statement-hero.json";

import WomanWatchingSunset from "components/Background/WomanWatchingSunset.jsx";
import aboutImage from "assets/img/about.png";

class AboutPage extends React.Component {
  render() {
    const { classes, ...rest } = this.props;
    return (
      <DefaultLayout>
        <Helmet>
          <title>about | we the shareholders</title>
          <meta property="og:title" content="about | we the shareholders"/>
          <meta name="twitter:title" content="about | we the shareholders"/>
          <meta name="description" content="Our mission is to fulfill the promise of corporate democracy and sustainable capitalism by enfranchising and organizing the world's shareholders."/>
          <meta property="og:description" content="Our mission is to fulfill the promise of corporate democracy and sustainable capitalism by enfranchising and organizing the world's shareholders."/>
          <meta name="twitter:description" content="Our mission is to fulfill the promise of corporate democracy and sustainable capitalism by enfranchising and organizing the world's shareholders."/>
          <meta property="og:image" content={`https://wetheshareholders.com${aboutImage}`}/>
          <meta name="twitter:image" content={`https://wetheshareholders.com${aboutImage}`}/>
          <meta property="og:image:alt" content="A woman sitting on the hood of a car, gazing into the distance, watching a colorful sunset above the clouds."/>
          <meta name="twitter:image:alt" content="A woman sitting on the hood of a car, gazing into the distance, watching a colorful sunset above the clouds."/>
        </Helmet>
        <Banner BackgroundImage={WomanWatchingSunset}>
          <div className={classes.container}>
            <GridContainer alignContent="space-around" alignItems="center" justify="center">
           <GridItem xs={12} sm={11}>
              <h1 className={classes.brandNameLarge}>we the shareholders
              <br/>
              <small className={classes.brandSloganLarge}>our shares. our votes. our future.</small>
              </h1>
              </GridItem>
            </GridContainer>
          </div>
        </Banner>
        <div className={classNames(classes.main, classes.greyBackground)}>
          <GridContainer alignItems="center">
            <GridItem xs={12}>
              <h2 className={classes.sectionTitle}>About Us</h2>
            </GridItem>
          </GridContainer>
          <div>
            <HeroCard hero={aboutHero} />
            <JoinTheMovementCta  listIds={[15]}/>
            <HeroCard hero={missionHero}/>
            <GridContainer justify="space-around" className={classNames(classes.greyBackground)}>
              <GridItem sx={12} sm={11} className={classNames(classes.greyBackground)}>
                <Quote plain quote={quotes.davos}/>
              </GridItem>
            </GridContainer>
            <EarlyAdopterCTA  listIds={[16]}/>
            <HeroCard hero={publicBenefitHero}/>
            <GridContainer justify="space-around" className={classNames(classes.greyBackground)}>
              <GridItem sx={12} sm={11} className={classNames(classes.greyBackground)}>
                <Quote plain quote={quotes.smith}/>
              </GridItem>
            </GridContainer>
            <MissingStepCTA  listIds={[17]}/>
            <TeamSection isOpened={false}/>
            <BlogSection/>
            <YourSharesMyFutureCTA  listIds={[18]}/>
          </div>
        </div>
        <Footer />
      </DefaultLayout>
    );
  }
}

export default withStyles(landingPageStyle)(AboutPage);
